<template>
    <div class="w-full flex flex-wrap mx-auto -px-2">
        <div class="w-full hidden lg:block px-2 lg:w-1/5">
            <sidebar :links="links" />
        </div>
        <div class="w-full lg:w-4/5 px-2">
            <router-view :key="$route.name"></router-view>
        </div>
    </div>
</template>

<script>
import Sidebar from "./sidebar";

export default {
    components: {
        Sidebar
    },

    data() {
        return {
            links: [
                {
                    title: "Пользователи",
                    route: {
                        name: "admin.users.index"
                    },
                    icon: "far fa-user-circle",
                    show: this.can("manage-users"),
                    index: null
                },

                {
                    title: "Права доступа",
                    route: {
                        name: "admin.permissions.index"
                    },
                    icon: "far fa-sad-cry",
                    index: null,
                    show: this.can("manage-permissions")
                },

                {
                    title: "Роли",
                    route: {
                        name: "admin.roles.index"
                    },
                    icon: "far fa-times-circle",
                    index: null,
                    show: this.can("manage-permissions")
                }
            ]
        };
    }
};
</script>